<template>
  <div class="filter-container pb-2">
    <v-radio-group v-model="radioGroup" class="mt-0" hide-details density="compact">
      <v-radio v-for="(item, idx) in options" :key="idx" class="filter-radio" :value="item.value" color="orange50">
        <template #label>
          <div class="filter-radio__label">
            {{ item.title }}
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
let filterDebounce = null

export default {
  name: 'RadioFilter',
  props: {
    value: { type: [String, Number], default: '' },
    isClear: { type: Boolean, default: false },
    keyValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
  },
  emits: ['returnFilter', 'updateClearBtn'],
  data() {
    return {
      filterLoading: false,
      radioGroup: this.value,
    }
  },
  computed: {
    showClearBtn() {
      return this.radioGroup.length > 0
    },
  },
  watch: {
    isClear(newVal) {
      if (newVal) {
        this.clearData()
        this.$emit('updateClearBtn', false)
      }
    },
    radioGroup() {
      clearTimeout(filterDebounce)
      filterDebounce = setTimeout(() => {
        this.estimateTotalCount()
      }, 500)
    },
  },
  methods: {
    checkActivated() {
      return this.radioGroup.length > 0
    },
    clearData() {
      this.radioGroup = this.value
    },
    estimateTotalCount() {
      this.$emit('updateClearBtn', this.checkActivated())
      this.$emit('returnFilter', [this.radioGroup || false])
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-container {
  max-height: calc(90vh - 265px);
  overflow-y: auto;

  .filter-radio {
    padding: 16px 20px;
    border-bottom: 1px solid $gray40;
    &__label {
      color: $black50;
    }
  }
}
</style>

<style lang="scss">
.v-input--selection-controls {
  .v-input__slot {
    & > .v-label {
      font-size: 15px;
      color: $black50;
    }
  }
}
</style>
